export const decision =
  (conditionFunction, trueOutcome, falseOutcome) => context =>
    conditionFunction(context) ? trueOutcome : falseOutcome;

export const decide = (context, decision) => {
  const outcome = decision(context);

  return typeof outcome === 'function' ? decide(context, outcome) : outcome;
};
